import { __ } from '@wordpress/i18n';

const Save = () => {
    return (null);
};

export default Save;
